import React from "react";
import { Link } from "react-router-dom";
import i18n from "../i18n";

export class PaymentCancelled extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section>
          <div
            className="bannerimg cover-image sptb-2"
            data-image-src="../assets/images/banners/banner2.jpg"
          >
            {/* <div className="header-text mb-0">
              <div className="container">
                <div className="text-center text-white ">
                  <h1 className="">Payment Cancelled</h1>
                  <ol className="breadcrumb text-center">
                    <li className="breadcrumb-item">
                      <Link exact="true" to="/">
                        Home
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item active text-white"
                      aria-current="page"
                    >
                      <Link exact="true" to="/enroll">
                        Enroll
                      </Link>
                    </li>
                  </ol>
                </div>
              </div>
            </div> */}
          </div>
        </section>

        <section className="sptb">
          <div className="container">
            <div className="container text-center">
              <div className="card p-5 m-5">
                <h1 className="h2 mb-7 text-danger py-3">
                  {i18n.t("payment_error_msg_title")}
                </h1>
                <p className="h4 font-weight-Automatic mb-8 leading-Automatic">
                  {i18n.t("payment_error_msg")}
                </p>
                <Link className="btn btn-warning" to="/">
                  {i18n.t("back")}
                </Link>
                <p className="h4 font-weight-Automatic mb-8 leading-Automatic">
                  {i18n.t("payment_error_msg_details")}
                </p>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
